import { MayNull, useAccountContext } from '@apeiron/temp'
import { useLazyQuery } from '@apollo/client'
import useMakeLeaderboard from '@src/deserialize/hook/useMakeLeaderboard'
import graphql from '@src/graphql/query/getBattleDemoGuildWarPvPLeaderboard'
import { BattleDemoGuildPvPLeaderboard } from '@src/types/battleDemo'
import * as RA from 'ramda-adjunct'
import { useCallback, useState } from 'react'

const useGetBattleDemoGuildWarPvPLeaderboard = (): Hook => {
  const [fetchGuildLeaderboard, { loading }] = useLazyQuery(graphql)

  const { account } = useAccountContext()

  const { makeGuildPvPLeaderboard } = useMakeLeaderboard()

  const [data, setData] = useState<MayNull<BattleDemoGuildPvPLeaderboard>>(null)

  const fetch = useCallback(
    async (request: Request): Promise<Response> => {
      const { season } = request

      const address = account?.walletAddress

      const variables = {
        season,
        walletAddress: RA.isNotNilOrEmpty(address) ? address : null
      }

      const response = await fetchGuildLeaderboard({ variables })

      const leaderboardData = makeGuildPvPLeaderboard(
        response.data.getPVPGuildLeaderboard
      )

      setData(leaderboardData)

      return { data: leaderboardData }
    },
    [account?.walletAddress, fetchGuildLeaderboard, makeGuildPvPLeaderboard]
  )

  return {
    data,
    loading,
    fetch
  }
}

type Request = {
  first: number
  season: string
  offset: number
}

type Response = {
  data: MayNull<BattleDemoGuildPvPLeaderboard>
}

type Hook = {
  data: MayNull<BattleDemoGuildPvPLeaderboard>
  loading: boolean
  fetch: (request: Request) => Promise<Response>
}

export default useGetBattleDemoGuildWarPvPLeaderboard
